import { render, staticRenderFns } from "./agriculturalInfoWindow.vue?vue&type=template&id=634b37b0&scoped=true"
import script from "./agriculturalInfoWindow.vue?vue&type=script&lang=js"
export * from "./agriculturalInfoWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634b37b0",
  null
  
)

export default component.exports